import LoadingCustom from './LoadingCustom';

export default LoadingCustom;
